<template>
  <div class="rule-modal">
    <van-overlay :show="visible" :lock-scroll="true" :z-index="300">
      <div class="wrapper" @click.stop>
        <div class="content" @touchmove.stop>
          <p class="rule-p red rule-title">参与默认规则：参与活动即视为同意活动规则，请参与活动前仔细阅读活动规则。</p>
          <div class="rule-h1">活动规则</div>
          <section class="rule-block">
            <div class="rule-h4">1、活动对象</div>
            <p class="rule-p">
              2026年8月1日-2026年9月30日期间历史首次开立我行借记卡Ⅰ类户的客户。
            </p>

            <div class="rule-h4">2、活动时间</div>
            <p class="rule-p rule-strong">（1）活动提升时间：</p>
            <p class="rule-p">8月份活动：2026年8月1日-2026年9月30日</p>
            <p class="rule-p">9月份活动：2026年9月1日-2026年10月31日</p>
            <p class="rule-p rule-strong">（2）权益领取时间：</p>
            <p class="rule-p">8月份开户客户权益领取时间：</p>
            <p class="rule-p">2026年9月5日10:00-2026年9月30日23:59</p>
            <p class="rule-p">2026年10月8日10:00-2026年10月31日23:59</p>
            <p class="rule-p">9月份开户客户权益领取时间：</p>
            <p class="rule-p">2026年10月8日10:00-2026年10月31日23:59</p>
            <p class="rule-p">2026年11月5日10:00-2026年11月30日23:59</p>
            <div class="rule-h4">3、活动内容</div>
            <p class="rule-p">
              活动当月历史首次开立我行借记卡Ⅰ类户，<span class="red">当月或次月</span>达到我行特定等级，即有机会在权益领取时间内进入活动界面，领取对应等级的奖励。<span class="red">每月奖励数量有限，先到先得，领完即止，每位客户活动期间仅可参与1次。</span>实物奖品图片仅供参考，以实际为准。各等级奖品不可重复获取，具体等级及奖励如下：
            </p>
            <table class="rule-table">
              <thead>
                <tr>
                  <th>开户当月或者次月内客户等级</th>
                  <th>权益</th>
                  <th>每月数量（份）</th>
                  <th>活动期间数量合计（份）</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td rowspan="6" class="rule-table__level">财富<br /><span class="red">(权益六选一)</span></td>
                  <td class="rule-table__left">38元微信立减金</td>
                  <td>350</td>
                  <td>1050</td>
                </tr>
                <tr>
                  <td class="rule-table__left">38元京东E卡</td>
                  <td>20</td>
                  <td>60</td>
                </tr>
                <tr>
                  <td class="rule-table__left">2400积分商城积分</td>
                  <td>20</td>
                  <td>60</td>
                </tr>
                <tr>
                  <td class="rule-table__left">中粮福临门唯粹东北长粒香米2.5kg</td>
                  <td>15</td>
                  <td>45</td>
                </tr>
                <tr>
                  <td class="rule-table__left">舒客红花清火惠享组合4支装ZHS-HH40</td>
                  <td>15</td>
                  <td>45</td>
                </tr>
                <tr>
                  <td class="rule-table__left">640厦门航空白鹭积分<strong>（鹭愿卡持卡客户专享）</strong></td>
                  <td>15</td>
                  <td>45</td>
                </tr>
                <tr>
                  <td rowspan="6" class="rule-table__level">白金<br /><span class="red">(权益六选一)</span></td>
                  <td class="rule-table__left">118元微信立减金</td>
                  <td>300</td>
                  <td>900</td>
                </tr>
                <tr>
                  <td class="rule-table__left">118元京东E卡</td>
                  <td>15</td>
                  <td>45</td>
                </tr>
                <tr>
                  <td class="rule-table__left">6500积分商城积分</td>
                  <td>15</td>
                  <td>45</td>
                </tr>
                <tr>
                  <td class="rule-table__left">超能自然天然洗衣液-香根草香3kg</td>
                  <td>10</td>
                  <td>30</td>
                </tr>
                <tr>
                  <td class="rule-table__left">星巴克绿野秘境透亮吸管杯473ml</td>
                  <td>10</td>
                  <td>30</td>
                </tr>
                <tr>
                  <td class="rule-table__left">1700厦门航空白鹭积分<strong>（鹭愿卡持卡客户专享）</strong></td>
                  <td>10</td>
                  <td>30</td>
                </tr>
                <tr>
                  <td rowspan="6" class="rule-table__level">黑金<br /><span class="red">(权益六选一)</span></td>
                  <td class="rule-table__left">388元微信立减金</td>
                  <td>30</td>
                  <td>90</td>
                </tr>
                <tr>
                  <td class="rule-table__left">388元京东E卡</td>
                  <td>5</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td class="rule-table__left">23000积分商城积分</td>
                  <td>5</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td class="rule-table__left">外交官拉杆箱HM-61082</td>
                  <td>5</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td class="rule-table__left">摩飞头部按摩仪MFP201Pro</td>
                  <td>5</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td class="rule-table__left">6100厦门航空白鹭积分<strong>（鹭愿卡持卡客户专享）</strong></td>
                  <td>5</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td rowspan="6" class="rule-table__level">私钻<br /><span class="red">(权益六选一)</span></td>
                  <td class="rule-table__left">588元微信立减金</td>
                  <td>5</td>
                  <td>15</td>
                </tr>
                <tr>
                  <td class="rule-table__left">588元京东E卡</td>
                  <td>2</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td class="rule-table__left">35000积分商城积分</td>
                  <td>2</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td class="rule-table__left">摩飞空气炸烤箱12升MR4014</td>
                  <td>2</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td class="rule-table__left">爱华仕斜杠行李箱大容量拉杆箱24英寸OCX6708-24</td>
                  <td>2</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td class="rule-table__left">9100厦门航空白鹭积分<strong>（鹭愿卡持卡客户专享）</strong></td>
                  <td>4</td>
                  <td>12</td>
                </tr>
              </tbody>
            </table>
            <div class="rule-h4">4、活动规则说明</div>
            <p class="rule-p rule-strong">（1）活动参与客户需满足如下条件：</p>
            <p class="rule-p">①活动开始前，名下从未开立过厦门国际银行Ⅰ类户；</p>
            <p class="rule-p">②若客户历史仅持有过Ⅱ类户/Ⅲ类户，活动期间首次升级为借记卡Ⅰ类户，则可以参与活动；</p>
            <p class="rule-p">③若客户曾经开立过Ⅰ类户，销户之后活动期间再次办理借记卡Ⅰ类户，则无法参与本次活动。</p>
            <p class="rule-p"><strong>（2）</strong>每月奖励<span class="red">数量有限，先到先得</span>，领完即止；<span class="red">整个活动期间每个客户只限领取1次权益。</span>各等级奖励不可重复获取、不支持跨等级领取，例如，客户等级达到黑金，则只能领取黑金礼奖励，无法领取白金礼或私钻礼奖励。</p>
            <p class="rule-p rule-strong">（3）客户当月等级由系统于次月5日（国庆期间顺延至节后首个工作日）出具结果并判断是否达标，若达标可选择对应等级的奖励。您可选择根据开户当月的等级领取奖励，也可选择根据开户次月的等级领取奖励，但<span class="red">活动期间奖励仅可领取一次。</span></p>
            <p class="rule-p rule-strong">①若您选择根据开户当月的等级领取对应奖励，则系统不再根据您开户次月的等级向您赠送奖励，即使次月的等级高于当月；</p>
            <p class="rule-p rule-strong">②若您未根据开户当月的等级领取对应奖励，则系统将并取两个月的最高等级作为最终结果向您赠送奖励，即使次月的等级低于当月。</p>
            <p class="rule-p rule-strong">客户可根据自身情况选择权益领取时间，<span class="red">最迟领取和兑换时间为开户月后2个自然月内，超期不予补发。</span></p>
            <p class="rule-p">举例：</p>
            <p class="rule-p rule-strong">客户8月开户，9月5日系统判断显示等级提升为白金，但客户选择不领取奖励，2026年10月8日系统判断等级较9月5日结果未提升，仍可于10月8日10:00至10月31日23:59期间领取白金等级礼品。</p>
            <p class="rule-p rule-strong">客户8月开户，9月5日系统判断显示等级提升为白金，可于9月5日10:00至9月30日23:59抽取白金等级礼品，领取完毕后，若10月8日等级进一步提升为黑金，也不可再领取黑金对应礼品。</p>
            <p class="rule-p rule-strong">客户8月开户，9月5日系统判断显示等级提升为白金，但客户选择不领取奖励，待2026年10月8日系统判断等级进一步提升至黑金后，可于10月8日10:00至10月31日23:59期间领取黑金对应礼品。</p>
            <p class="rule-p">（4）权益领取路径：厦门国际银行APP-活动中心-三季度财富晋升计划</p>
          </section>
        </div>
        <button
          class="close-btn"
          type="button"
          aria-label="关闭"
          @click.stop="onClose"
        >
          <img :src="imgClose" alt="" />
        </button>
      </div>
    </van-overlay>
  </div>
  <!-- 细则弹框组件 -->
</template>

<script>
export default {
  name: "RuleModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      imgClose: require("@/assets/imgs/xibMaintain/record-modal-close.png"),
    };
  },
  methods: {
    onClose() {
      this.$emit("confirm");
    },
  },
};
</script>

<style lang="less" scoped>
.rule-modal {
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    // padding-top: 70px;
    box-sizing: border-box;
  }

  .content {
    background: linear-gradient(to bottom,
        #D3FBFC 0%,
        #ffffff 40%,
        #ffffff 100%);
    border-radius: 20px;
    padding: 0 19px 12px;
    box-sizing: border-box;
    color: #000301;
    width: 85%;
    margin: 0 auto;
    max-height: min(60vh, calc(100dvh - 120px));
    overflow: auto;

    .rule-h1 {
      font-size: 20px;
      color: #000;
      text-align: center;
      font-weight: bold;
      padding: 28px 0 0px;
    }

    .rule-h2 {
      font-size: 16px;
      font-weight: 700;
      color: #111;
      margin: 18px 0 10px;
      line-height: 1.35;

      &:first-of-type {
        margin-top: 0;
      }
    }

    .rule-block {
      margin-bottom: 4px;
    }

    .rule-h3 {
      font-size: 15px;
      font-weight: 700;
      color: #111;
      margin: 14px 0 8px;
      line-height: 1.4;
    }

    .rule-h4 {
      font-size: 14px;
      font-weight: 600;
      color: #222;
      margin: 12px 0 6px;
      line-height: 1.4;
    }
    .red{
      color: #FF0000;
    }
    .rule-img{
      width: 100%;
      height: auto;
      display: block;
    }
    .rule-strong {
      font-weight: bold;
    }
    strong {
      font-weight: bold;
    }
    .rule-title {
      padding-top: 20px;
      color: #FF0000!important;
    }

    .rule-p {
      font-size: 12px;
      line-height: 1.65;
      color: #333;
      text-align: justify;

      &--mt {
        margin-top: 4px;
      }

      &--strong {
        font-weight: 600;
        color: #222;
      }
    }

    .rule-em {
      font-weight: inherit;

      &--accent {
        color: #e54c5e;
      }

      &--red {
        color: #ff0000;
      }
    }

    .rule-table {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
    font-size: 10px;
    line-height: 1.35;
    margin: 8px 0 14px;
    color: #000;

    th,
    td {
      border: 1px solid #000;
      padding: 4px 3px;
      text-align: center;
      vertical-align: middle;
      word-break: break-all;
    }

    th {
      background: #f2f2f2;
      font-weight: 700;

      &:nth-child(1) {
        width: 24%;
      }

      &:nth-child(2) {
        width: 42%;
      }

      &:nth-child(3),
      &:nth-child(4) {
        width: 20%;
      }
    }

    &__level {
      font-weight: 700;
    }

    &__left {
      text-align: left!important;
    }

    strong {
      font-weight: 700;
    }
  }
  }

  .close-btn {
    margin-top: 49px;
    padding: 0;
    border: 0;
    background: transparent;
    outline: none;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;

    img {
      display: block;
      width: 29px;
      height: 29px;
    }
  }
}
</style>
